export default __webpack_public_path__ + "images/5W.ebae9d9.png";